import redis from 'redis';

const cachePrefix = (process.env.NEXT_PUBLIC_APP_ENV === 'production') ? 'next_prod' : 'next_dev';

/**
 * @param cacheKey
 *
 * @return Promise
 * */
export function getRedisCache(cacheKey) {
    const client = redis.createClient({db: process.env.NEXT_PUBLIC_REDIS_DB});
    const fullCacheKey = cachePrefix + ':' + cacheKey;

    return new Promise((resolve, reject) => {
        client.get(fullCacheKey, async (err, cachedData) => {
            let data = null;

            if (err) reject(err);

            if (cachedData) {
                data = JSON.parse(cachedData);
            }

            resolve(data)
        });
    })
}

/**
 * @param cacheKey
 * @param data {Object}
 * @param timeToLive
 *
 * @return Promise
 * */
export function storeRedisCache(cacheKey, data, timeToLive = 600) {
    const client = redis.createClient({db: process.env.NEXT_PUBLIC_REDIS_DB});
    const fullCacheKey = cachePrefix + ':' + cacheKey;

    return new Promise((resolve, reject) => {
        client.set(fullCacheKey, JSON.stringify(data), 'EX', timeToLive, redis.print);

        resolve(true)
    })
}